import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_SETTINGS = {
  contact_email: "monteyolli@outlook.com",
  contact_phone: "+52 775 105 2230",
  contact_website: "www.monteyolli.com",
  notification_email: "monteyolli@outlook.com",
  maintenance_mode: true,
};

export async function fetchSettings() {
  try {
    const r = await axios.get(`${API}/settings`);
    return { ...DEFAULT_SETTINGS, ...r.data };
  } catch {
    return DEFAULT_SETTINGS;
  }
}
